module.exports = __webpack_public_path__ + "img/img57.7ce889c7.svg";